import { Fragment } from 'react';
import { Linking, View } from 'react-native';
import { Divider, Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import Button from '../../Components/Button';
import constants from '../../Config/constants';
import messages from '../../Config/messages';
import useAlert from '../../Hooks/useAlert';
import Service from '../../Service';
import themeStyle from '../../Theme/styles';
import { SECTION_TITLE_LIGHT } from '../../Theme/typographyProps';

import useCheckoutHandler from './controller/useCheckoutHandler';
import styles from './styles';

const PickupLocationRow = ({ disabled }: { disabled: boolean }) => {
  const alert = useAlert();
  const { checkoutInfo, isCurbside, isPickup } = useCheckoutHandler();

  const _onPress = () => {
    if (lodashIsEmpty(checkoutInfo.store_geocode_location)) {
      const { title, message } = messages.STORE_LOCATION_NOT_AVAILABLE;
      return alert(title, message);
    }
    const url = Service.getStoreMapUrl(
      checkoutInfo.store_name,
      checkoutInfo.store_geocode_location.lat,
      checkoutInfo.store_geocode_location.lng,
    );
    Linking.openURL(url);
  };

  if (!isPickup || !isCurbside) return null;

  return (
    <Fragment>
      <View style={themeStyle.pageVerticalSpacingMedium}>
        <View style={styles.webBox}>
          <Text style={themeStyle.spacingBottomSmall} {...SECTION_TITLE_LIGHT}>
            Pickup Location
          </Text>

          <Button
            testID="storeLocation"
            onPress={_onPress}
            disabled={disabled}
            plain
          >
            <Text category="p2" style={themeStyle.underline}>
              {checkoutInfo.store_location}
            </Text>
          </Button>
        </View>
      </View>
      {!constants.isWeb && <Divider style={themeStyle.divider} />}
    </Fragment>
  );
};

export default PickupLocationRow;
